module.exports = __webpack_public_path__ + "static/img/06.8886849.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/subscribe/06.jpg
// module id = pv81
// module chunks = 1